import Index from "./apps/pages/layout/Index";

function App() {
  return (
    <Index />
  );
}

export default App;
